import axios from "axios";
import { use } from "react";
// axios.defaults.withCredentials = true;

// Ambil token dari cookie dan tambahkan ke setiap request
axios.interceptors.request.use((config) => {
  const token = getCookie("XSRF-TOKEN");
  if (token) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token);
  }
  return config;
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export const DepositApi = {
  index: async (firstDate, endDate, userId) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token");
      const userKey = sessionStorage.getItem("user_key");
      if (!apiUrl || !token || !userKey) {
        throw new Error(
          "API URL, token, or user key is not set in environment variables or session storage."
        );
      }

      console.log("firstDate =", firstDate, "| typeof:", typeof firstDate);
      console.log("endDate =", endDate, "| typeof:", typeof endDate);

      let url = `${apiUrl}/deposits`;
      if (userId) {
        url = `${apiUrl}/deposit-by-user/${userId}`;
      }

      console.log("url =", url);

      const response = await axios.get(url, {
        params: {
          first_date: firstDate,
          end_date: endDate,
        },
        headers: {
          "Content-Type": "application/json",
          "Access-Key": process.env.REACT_APP_ACCESS_KEY,
          "User-Key": userKey,
          Authorization: "Bearer " + token,
        },
      });

      if (response.status !== 200) {
        throw new Error(
          "Failed to fetch customers with status: " + response.status
        );
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching customers:", error);
      throw error;
    }
  },

  show: async (id) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token");
      const userKey = sessionStorage.getItem("user_key");

      if (!apiUrl || !token || !userKey) {
        throw new Error(
          "API URL, token, or user key is not set in environment variables or session storage."
        );
      }
      const response = await axios.get(`${apiUrl}/deposit/${id}`, {
        headers: {
          "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
          Authorization: `Bearer ${token}`, // Use token from session storage
          "User-Key": userKey, // Use user key from session storage
          "Content-Type": "application/json",
        },
      });
      if (response.status !== 200) {
        throw new Error(
          "Failed to fetch customer with status: " + response.status
        );
      }
      if (response.data.error_code !== 200) {
        throw new Error("Failed to fetch customer: " + response.data.message);
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching customer:", error);
      throw error;
    }
  },
};
